import React from 'react';

import { ListItemIcon, SvgIcon, SvgIconProps } from '@mui/material';
import _ from 'es-toolkit/compat';

import type { SxProp } from 'src/types/mui';
import { composeSx } from 'src/utils/styles';

type SvgIconComponent = typeof SvgIcon;

type NavListItemIconProps = {
  sx?: SxProp;
  icon: SvgIconComponent;
  iconProps?: SvgIconProps;
};

export const NavListItemIcon: React.FC<NavListItemIconProps> = ({ sx, icon, iconProps }) => {
  return (
    <ListItemIcon sx={composeSx(listItemIconStyles, sx)}>
      {renderIcon(icon, iconProps)}
    </ListItemIcon>
  );
};
const renderIcon = (icon: SvgIconComponent, iconProps?: SvgIconProps) => {
  const Icon = icon;
  return (
    <Icon style={{ fontSize: 'inherit', ...iconProps?.style }} {..._.omit(iconProps, 'style')} />
  );
};

const listItemIconStyles: SxProp = {
  minWidth: 'auto',
  color: 'inherit',
};
